import {
    SET_ALL_TRANSLATIONS
} from "../actions/translationsAction";

export default (state = [], action) => {
    switch (action.type) {
        case SET_ALL_TRANSLATIONS:
            return action.payload
        default:
            return state;
    }
}